import React, { useState } from 'react';
import Image from './smallerComponent/Image';
import Logo from '../images/logo.svg';
import Link from './smallerComponent/Link';
import Button from './smallerComponent/Button';
import Modal from 'react-modal';

export default function Nav(){
    const [isOpen, setIsOpen] = useState(false);

    const customStyles = {
        content : {
            top                   : '0',
            left                  : '0',
            right                 : 'auto',
            bottom                : 'auto',
            color       : 'white',
            backgroundColor       : 'hsl(180, 66%, 49%)',
            width                 :  '100%',
            margin: '0 auto',
            textAlign: 'center',
            padding: '0 -40 0 0',
            fontSize: '14px'

        }
    }
  function displayModal(){
    setIsOpen(true)
  }
  function close(){
       setIsOpen(false)
  }
    return(
         <div className="navBar">
            <div className="left">
               <div className="left">
               <Image className="navImage" src={Logo} alt={Logo}/>
               </div>
                 <div className="right">
             <Link value="Features"/>
             <Link value="Printing"/>
             <Link value="Resources"/>
             </div>
             <div id="smallS" onClick={displayModal}>
                 <div>
                     <hr style={{border: "2px solid hsl(180, 66%, 49%)", background:"hsl(180, 66%, 49%)"}}/>
                     <hr style={{border: "2px solid hsl(180, 66%, 49%)", background:"hsl(180, 66%, 49%)"}}/>
                     <hr style={{border: "2px solid hsl(180, 66%, 49%)", background:"hsl(180, 66%, 49%)"}}/>
                 </div>
                
             </div>
            </div>
            <Modal  style={customStyles} isOpen={isOpen} onRequestClose={close}>
                 <input value="X" type="submit" onClick={close} className="x" style={{backgroundColor:'hsl(180, 66%, 49%)', border:'none', color:'white', float: 'right', margin:'20px 20px 100px 0px'}}/>
                 <p style={{margin:"40px 0px 0px 0px"}}>Features</p>
                 <p>Printing</p>
                 <p>Resources</p>
             </Modal>
             <div className="right">
                 <Button className="login" type="submit" value="Login" />
                 <Button className="signup"  type="submit" value="Sign Up"/>
             </div>
         </div>
    )
}